import { render, staticRenderFns } from "./_themeContentGroup.vue?vue&type=template&id=09476490&lang=pug"
import script from "./_themeContentGroup.vue?vue&type=script&lang=js"
export * from "./_themeContentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports